// Domain
import { SupportTicketRepository } from '@/modules/zendesk/support-ticket/domain/repositories/support-ticket-repository';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class SupportTicketDummyRepository implements SupportTicketRepository {
  create(): Promise<void> {
    return Promise.resolve();
  }
}
